module.exports = __webpack_public_path__ + "static/media/flag-round-ru.b36b3e38.png";